<div class="formula-card"
    [class.formula-card--personalizada]="usarPersonalizada"
    [class.formula-card--recolhido]="estaRecolhido">

    @if (mostrarVigencia) {
    @if (recolhivel) {
    <button type="button" class="vigencia-header vigencia-header--expansivel" [ngClass]="vigencia.classe"
        [attr.aria-expanded]="!estaRecolhido" (click)="alternarRecolhimento()">
        <mat-icon class="material-symbols-outlined vigencia-header-icon">{{ vigencia.icone }}</mat-icon>
        <span class="vigencia-header-texto">{{ vigencia.texto }}</span>
        <mat-icon class="material-symbols-outlined vigencia-header-seta">
            {{ estaRecolhido ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
        </mat-icon>
    </button>
    } @else {
    <div class="vigencia-header" [ngClass]="vigencia.classe">
        <mat-icon class="material-symbols-outlined vigencia-header-icon">{{ vigencia.icone }}</mat-icon>
        <span class="vigencia-header-texto">{{ vigencia.texto }}</span>
    </div>
    }
    }

    @if (!estaRecolhido) {
    @if (mostrarCabecalho) {
        <div class="formula-card-header">
            <div class="formula-tags">
                @if (variavel; as variavel) {
                <span class="status-badge badge-variavel" [ngClass]="classeVariavel(variavel)" [attr.data-chave]="variavel.chave || variavel.tagXml || variavel.nome">
                    @if (isVariavelParametro(variavel)) {
                    <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span>
                    }
                    @if (variavel.possuiFormulaAplicavel) {
                    <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span>
                    }
                    <span class="variavel-badge-descricao">{{ variavel.descricao }}</span>
                    <span class="variavel-badge-nome">{{ '{' + variavel.nome + '}' }}</span>
                </span>
                }
            </div>

            <div class="formula-acoes">
            @if (mostrarRestaurarFormula) {
            <button mat-stroked-button type="button" class="btn-filter btn-restaurar" (click)="restaurarFormula()">
                <mat-icon>restart_alt</mat-icon>
                Restaurar fórmula
            </button>
            }            

            @if (mostrarToggle) {
            <mat-slide-toggle class="app-toggle-compact"
                [checked]="usarPersonalizada"
                (change)="togglePersonalizada($event)">
                Usar fórmula personalizada
            </mat-slide-toggle>
            }

            @if (mostrarRestaurarPadrao) {
            <button mat-stroked-button type="button" class="btn-filter btn-restaurar" (click)="restaurarPadrao()">
                <mat-icon>restart_alt</mat-icon>
                Restaurar padrão
            </button>
            }

            @if (mostrarAlterarModelo) {
            <button mat-stroked-button type="button" class="btn-filter btn-alterar-modelo"
                (click)="toggleAlterarModelo()">
                <mat-icon>{{ secaoAlterarAberta ? 'keyboard_arrow_up' : 'swap_horiz' }}</mat-icon>
                {{ secaoAlterarAberta ? 'Fechar' : 'Alterar modelo' }}
            </button>
            }
            </div>
        </div>

        <div class="formula-card-header">
            <div class="formula-tags">
            @if (mostrarBadgeModelo && modeloAtual; as modelo) {
            <span class="status-badge" [ngClass]="badgeClasses.modelo" style="font-size:0.75rem;">
                {{ rotuloModelo(modelo) }}
            </span>
            }
            @if (modeloAtualEhPadrao) {
            <span class="status-badge" [ngClass]="classePadrao" style="font-size:0.75rem;">
                {{ rotuloPadrao }}
            </span>
            }

            @if (usarPersonalizada) {
            <span class="status-badge" [ngClass]="badgeClasses.personalizada" style="font-size:0.75rem;">Personalizada</span>
            }

            </div>
        </div>
    }

    @if (formula.descricao) {
    <p class="formula-desc text-secondary mb-2">{{ formula.descricao }}</p>
    }

    @if (!usarPersonalizada && modeloAtual; as modelo) {
    <app-formula-expressao-section
        [expressao]="modelo.expressao"
        [variaveis]="formula.variaveis">
    </app-formula-expressao-section>
    }

    @if (usarPersonalizada && modo === FormulaCardModoEnum.Listagem) {
    <app-formula-expressao-section
        [expressao]="expressaoAtual"
        [variaveis]="formula.variaveis">
    </app-formula-expressao-section>
    }

    @if (secaoAlterarAberta) {
    <app-alterar-modelo-section
        [formula]="formula"
        [modo]="modo"
        [modeloSelecionado]="modeloAtualId"
        (modeloSelecionadoChange)="selecionarModelo($event)"
        (modeloEmpresaSelecionado)="onModeloEmpresaSelecionado($event)">
    </app-alterar-modelo-section>
    }

    @if (usarPersonalizada && modo === FormulaCardModoEnum.Editor) {
    <app-formula-editor-section
            [expressao]="expressaoAtual"
            [variaveis]="formula.variaveis"
            [tipoArredondamento]="tipoArredondamento"
            [casasDecimais]="casasDecimais"
            [dataVigenciaInicio]="dataVigenciaInicio"
            [dataVigenciaFim]="dataVigenciaFim"
            [mostrarVigencia]="mostrarVigencia"
            (editorChange)="onEditorChange($event)">
    </app-formula-editor-section>
    }
    }

</div>
